module.exports = __webpack_public_path__ + "static/img/four.90065e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/radishImg/four.png
// module id = EWVi
// module chunks = 1